/*
 * File: customersParams.ts
 * Project: beaker
 * -----
 * Last Modified: 16 Mar 2022 12:16:43 am
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GetCustomersParams } from 'models/Customer';

const initialState: GetCustomersParams = {
  offset: 0,
  dataAreaId: undefined,
  customerNameContains: undefined,
  customerAccountContains: undefined,
  orderByField: undefined,
  orderbyDirection: undefined
};

export const beautifulDayMonsterCustomersParams = createSlice({
  name: 'beautifulDayMonsterCustomersParams',
  initialState,
  reducers: {
    setOffset: (state, { payload }: PayloadAction<GetCustomersParams['offset']>) => {
      state.offset = payload;
    },
    incrementOffset: (state) => {
      state.offset += 25;
    },
    setDataAreaId: (state, { payload }: PayloadAction<GetCustomersParams['dataAreaId']>) => {
      state.dataAreaId = payload;
      state.offset = 0;
    },
    setCustomerNameContains: (state, { payload }: PayloadAction<GetCustomersParams['customerNameContains']>) => {
      state.customerNameContains = payload;
      state.offset = 0;
    },
    setCustomerAccountContains: (state, { payload }: PayloadAction<GetCustomersParams['customerAccountContains']>) => {
      state.customerAccountContains = payload;
      state.offset = 0;
    },
    setOrderByField: (state, { payload }: PayloadAction<GetCustomersParams['orderByField']>) => {
      state.orderByField = payload;
      state.offset = 0;
    },
    setOrderbyDirection: (state, { payload }: PayloadAction<GetCustomersParams['orderbyDirection']>) => {
      state.orderbyDirection = payload;
      state.offset = 0;
    }
  }
});

export const { setOffset, incrementOffset, setCustomerAccountContains, setCustomerNameContains, setDataAreaId, setOrderByField, setOrderbyDirection } = beautifulDayMonsterCustomersParams.actions;
